import { UnitType } from "types/app";
import { Distance, DistanceUnits } from "utils/units/Distance";
import { formatNumber } from "./formatNumber";

export const formatElevation = (
  meters: number,
  unitType: UnitType,
  decimals: number
) => {
  const unitName: DistanceUnits = unitType === "metric" ? "m" : "ft";
  const elevation = new Distance(meters).get(unitName);
  return `${formatNumber(elevation, decimals)} ${unitName}`;
};
